import type { JSX } from 'react';

import ArizonaSvg from './resources/arizona';
import GeorgiaSvg from './resources/georgia';
import MichiganSvg from './resources/michigan';
import NevadaSvg from './resources/nevada';
import PennsylvaniaSvg from './resources/pennsylvania';
import WisconsinSvg from './resources/wisconsin';

export type StateName = 'arizona' | 'georgia' | 'nevada' | 'pennsylvania' | 'wisconsin' | 'michigan';

interface StateProjectionProps {
    state: StateName;
    color: string;
    opacity: number;
}

const StateProjection = ({ state, color, opacity }: StateProjectionProps): JSX.Element => {
    return (
        <div className="flex">
            {state === 'arizona' && <ArizonaSvg color={color} opacity={opacity} />}
            {state === 'georgia' && <GeorgiaSvg color={color} opacity={opacity} />}
            {state === 'michigan' && <MichiganSvg color={color} opacity={opacity} />}
            {state === 'nevada' && <NevadaSvg color={color} opacity={opacity} />}
            {state === 'pennsylvania' && <PennsylvaniaSvg color={color} opacity={opacity} />}
            {state === 'wisconsin' && <WisconsinSvg color={color} opacity={opacity} />}
        </div>
    );
};

export default StateProjection;
